import {combineReducers} from 'redux'
import blogReducer from './blogReducer';
import routeReducer from './routeReducer';

export default combineReducers({
  blogs: blogReducer,
  route: routeReducer
})